<template>
  <div class="panel-body promotion-info">
    <div class="row hpanel">
      <base-table
        :url="'PromotionResult/list'"
        :method="'post'"
        :columns="$options.promotionColumns"
        :isSearchable="true"
        :isSearchMultiple="true"
        :malls="malls"
        @keyword="onHandleSearch"
      >
        <template slot="orderDate" slot-scope="props">
          <span>{{ formatDate(props.rowData.orderDate) }}</span>
        </template>
        <template slot="itemImageUrl" slot-scope="props">
          <img :src="prepareImgSrc(props.rowData.itemImageUrl)" class="product-img"/>
        </template>
        <template slot="detail" slot-scope="props">
          <p v-html="props.rowData.detail"></p>
        </template>
          <template slot="totalAmount" slot-scope="props">
          <span v-bind:class="{ 'text-red': isMinus(props.rowData.totalAmount) }">{{ formatAmount(props.rowData.totalAmount) }}</span>
        </template>
        <template slot="mallCode" slot-scope="props">
          <img :src="prepareImgSrc(props.rowData.mall)"/>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import BaseTable from '@/components/BaseTableAPI'
import MallService from '@/services/mallservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    BaseTable
  },
  data () {
    return {
      malls: [
        {
          mallCode: null,
          mallName: 'すべて'
        }
      ]
    }
  },
  promotionColumns: [
    {
      title: '日付',
      name: 'orderDate',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-sm-3 w-100'
    },
    {
      title: '画像',
      name: 'itemImageUrl',
      customCell: true,
      sortable: false,
      cellClass: 'text-center',
      headerClass: 'col-sm-2 w-100'
    },
    {
      title: 'ASIN',
      name: 'asin',
      cellClass: 'text-center',
      headerClass: 'col-sm-3'
    },
    {
      title: '商品名',
      name: 'detail',
      customCell: true,
      cellClass: 'text-left',
      headerClass: 'col-sm-9 product-name'
    },
    {
      title: '広告費(税込)',
      name: 'totalAmount',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-sm-2 w-120'
    },
    {
      title: 'モール',
      name: 'mallCode',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-sm-3 w-150'
    }
  ],
  created () {
    this.getAllMall()
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'promotion-info') {
      let logParams = {
        name: eventCode.promotion.info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  methods: {
    isMinus (value) {
      return value < 0
    },
    formatAmount (value) {
      return `¥${Util.formatMoney(value)}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD HH:mm') : null
    },
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    getAllMall () {
      MallService.getAll()
        .then((response) => {
          this.malls = [
            ...this.malls,
            ...response.malls
          ]
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    onHandleSearch (keyword) {
      let mall = 'すべて'
      if (keyword.mallCode && keyword.mallCode.length) {
        mall = this.malls.filter(item => item.mallCode === keyword.mallCode[0])[0]
      }
      let logParams = {
        name: eventCode.promotion.info_tab.click_filter_button,
        properties: {
          keyword: {
            detail: keyword.detail,
            startOfferDate: keyword.startOfferDate,
            endOfferDate: keyword.endOfferDate,
            mall: mall
          }
        }
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>

<style scoped>
.promotion-info /deep/ .box-base-table-search {
  display: block !important;
  justify-content: unset;
  align-items: unset;
  flex-wrap: unset;
}
.promotion-info /deep/ .box-base-table-search .search-multiple {
  flex-grow: unset;
  margin-right: unset;
  display: flex;
  align-items: center;
}
.promotion-info /deep/ .box-base-table-search .search-multiple input {
  margin-right: 30px;
}

@media (max-width: 1024px) {
  /* .hpanel /deep/ .flexbox {
    display: table !important;
  } */
  .hpanel /deep/ .sale-detail-search {
    display: inline;
  }
  .hpanel /deep/ .datepicker-end {
    margin-left: 50px;
  }
  .hpanel /deep/ .search-block-detail {
    margin-top: 10px;
    width: 287px;
  }
  .hpanel /deep/ .search-block-detail>label {
    width: 92px;
  }
  .hpanel /deep/ .search-block-mall {
    margin-left: 50px;
    width: 264px;
  }
  /* .hpanel /deep/ .btn-warning {
    margin-top: 10px;
    margin-left: 76px;
  } */
  .promotion-info /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 75px;
    margin-top: 10px;
  }
}
@media (max-width: 425px) {
  .hpanel /deep/ .datepicker-end {
    margin-top: 10px;
    margin-left: 21px;
  }
  .hpanel /deep/ .search-block-detail {
    margin-top: 10px;
    margin-left: 38px;
    width: 250px;
  }
  .hpanel /deep/ .search-block-detail>label {
    width: 30px;
  }
  .hpanel /deep/ .search-block-mall {
    margin-top: 10px;
    margin-left: 24px;
    width: 264px;
  }
  .hpanel /deep/ .table-wrapper {
    overflow-x: auto !important;
  }
  .hpanel /deep/ .table-wrapper .table {
    min-width: 700px !important;
    max-width: none !important;
  }
  .promotion-info /deep/ .box-base-table-search .sale-detail-search .datepicker-start label {
    margin-right: 14px;
  }
}

@media (max-width: 992px) {
  /deep/ .table-wrapper {
    overflow-x: auto;
  }
  /deep/ .table {
    width: auto;
    min-width: max-content;
  }
  /deep/ .table thead tr .product-name {
    width: 220px;
  }
}
@media (min-width: 1200px) {
  .promotion-info /deep/ .box-base-table-search .sale-detail-search {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/promotion/PromotionInfo.vue